const initialState = {
    product: {
    	title: '',
        description: '',
    	image : '', 
    	images: [],
    	rate: 0, 
    	totalPoint: 0,
    	commentCount: 0, 
    	questionCount: 0,
        isShowAllAttributes: false,
    },
    selectedSku: '',
    selectedSeller: '', 
    descriptionExpanded: false,
    isSheetAttributesOpen: false,
    isSheetSellersOpen: false,
    productComments: [],
};

const productDetails = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_PRODUCT_DETAILS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default productDetails;
